var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHilo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78723 11.8333C9.73985 11.8333 10.554 11.1859 11.0011 10.7397C11.4488 11.1859 12.2606 11.8333 13.2132 11.8333C14.8534 11.8333 16 10.7423 16 9.18096C16 7.45953 14.5768 6.34661 13.2004 5.27087C12.5505 4.76253 11.8772 4.23757 11.3612 3.65399C11.3185 3.60582 11.2653 3.56709 11.2054 3.5405C11.1454 3.51391 11.0801 3.50009 11.014 3.5H10.9874C10.9212 3.50014 10.8558 3.51399 10.7958 3.54057C10.7358 3.56716 10.6825 3.60585 10.6397 3.65399C10.1233 4.2367 9.45044 4.7621 8.80053 5.27043C7.42366 6.34617 6 7.45865 6 9.18053C6.00046 10.7423 7.14617 11.8333 8.78723 11.8333Z",
    fill: "#6E7589"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 13.5C10.4356 13.3329 11.5638 13.3329 12.6663 13.5C11.5638 12.0799 10.9997 9.33331 10.9997 9.33331C10.9997 9.33331 10.4441 12.0799 9.33301 13.5Z",
    fill: "#6E7589"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 1L1 3.9925H3.25V9.25H4.75V3.9925H7L4 1Z",
    fill: "#6E7589"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 16.2575V11H16.25V16.2575H14L17 19.25L20 16.2575H17.75Z",
    fill: "#6E7589"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHilo);
export default __webpack_public_path__ + "static/media/hilo.99cd19d151f43aa99809961dabef1da9.svg";
export { ForwardRef as ReactComponent };